import { createSlice } from "@reduxjs/toolkit";

export const editInitialState = {
  history: [],
  member: null,
};

export const sliceName = "edit";
export const editSlice = createSlice({
  name: sliceName,
  initialState: editInitialState,
  reducers: {
    setEditHistory: (state, action) => {
      state.history = [...state.history, action.payload];
      return state;
    },
    setEditMember: (state, action) => {
      state.member = action.payload;
    },
    setVivo: (state, action) => {
      state.member.vivo = action.payload;
    },
  },
});

export const { setEditHistory, setEditMember, setVivo } = editSlice.actions;
export const selectEditHistory = (state) => state[sliceName].result;
export const selectEditMember = (state) => state[sliceName].result;
export const selectVivo = (state) => state[sliceName]?.member?.vivo ?? -1;
